import Multiselect from 'vue-multiselect';
import VueScrollTo from 'vue-scrollto';
import { DatePicker } from 'element-ui';
import VueRecaptcha from 'vue-recaptcha';
import { v4 as uuidv4 } from 'uuid';
import { ACTIVE_CAMPAIGN } from '../../common/utils/constants';

export default {
	name: 'frm02-form',
	components: {
		'multiselect': Multiselect,
		'el-date-picker': DatePicker,
		VueRecaptcha
	},
	data() {
		return {
			fromId: '',
			model: {},
			modelErrors: {},
			validationErrors: {},
			submitted: false,
			serverError: false,
			scrollDurationInMs: 500,
			scrollOffsetInPx: -20,
			sessionToken: '',
			sourceCampaign: ''
		};
	},
	created() {
		this.fromId = window.formId;
		this.model = JSON.parse(JSON.stringify(window.formModel));
		this.modelErrors = JSON.parse(JSON.stringify(window.formModel));
		this.validationErrors = JSON.parse(JSON.stringify(window.formValidation));
		this.sessionToken = uuidv4();
		this.sourceCampaign = window.sourceCampaign;
	},
	methods: {
		validateRecaptcha() {
			if (!this.validateRequiredFields()) {
				this.$refs.recaptcha.execute();
			}
		},

		onRecaptchaSuccess(token) {
			this.submitHandler(token);
		},

		onRecaptchaFailed() {
			console.error('Nem sikerült a recaptcha validáció.');
		},
		errorFactory(errors) {
			errors.forEach(error => {
				error.errors.forEach(err => {
					this.modelErrors[error.field] = true;
					this.validationErrors[error.field][err] = true;
				});
			});
		},
		validateRequiredFields() {
			let hasError = false;
			let hasScrolled = false;

			for (let i in this.validationErrors) {
				if (Object.keys(this.validationErrors[i]).includes('required')) {
					if (!this.model[i] || typeof this.model[i] === 'object' && Object.keys(this.model[i]).length === 0) {
						this.validationErrors[i].required = true;

						if (i !== 'newsletter_type' || this.model.newsletter) {
							hasError = true;

							if (!hasScrolled) {
								this.scrollToError(`[name="${i}"]`);
								hasScrolled = true;
							}
						}
					} else {
						this.validationErrors[i].required = false;
					}
				}
			}

			return hasError;
		},

		scrollToError(element, offset) {
			VueScrollTo.scrollTo(element, this.scrollDurationInMs, { offset: offset || this.scrollOffsetInPx });
		},
		resetValidation() {
			this.modelErrors = JSON.parse(JSON.stringify(window.formModel));
			this.validationErrors = JSON.parse(JSON.stringify(window.formValidation));
		},
		submitHandler(recaptchaToken) {
			// reset serverError
			if (this.serverError) {
				this.serverError = false;
			}

			const formData = {
				1: this.model
			};

			formData[1].recaptcha = recaptchaToken;

			Axios.post(`/apps/formpost/${this.fromId}/sessions/${this.sessionToken}/complete`, formData)
				.then(response => {
					this.resetValidation();

					if (response.data.status && response.data.status === 'OK') {
						this.submitted = true;
						document.querySelector('html').style.overflow = 'hidden'
					} else {
						this.$refs.recaptcha.reset();
					}

					if (response.data['1'] && response.data['1'].length) {
						this.errorFactory(response.data['1']);
						this.scrollToError('#' + response.data['1'][0].field);
					}
				}).catch(() => {
					this.serverError = true;
					this.scrollToError('.frm02-form', 0);
				});

			// ActiveCampaign
			let activeCampaignData = {
				contact: {
					email: formData[1].email,
					firstName: formData[1].first_name,
					lastName: formData[1].last_name,
					phone: formData[1].phone,
					fieldValues: [
						{
							field: ACTIVE_CAMPAIGN.SOURCE_CAMPAIGN,
							value: this.sourceCampaign
						},
						{
							field: ACTIVE_CAMPAIGN.COMPANY_NAME,
							value: formData[1].company_name
						},
						{
							field: ACTIVE_CAMPAIGN.GDPR,
							value: formData[1].terms === 'adatkezelés elfogadása' ? ACTIVE_CAMPAIGN.GDPR_TRUE_VALUE : ACTIVE_CAMPAIGN.GDPR_FALSE_VALUE
						},
						{
							field: ACTIVE_CAMPAIGN.CONTACT_JOBTITLE,
							value: formData[1].post
						},
						{
							field: ACTIVE_CAMPAIGN.NEWSLETTER,
							value: formData[1].newsletter === 'Hírlevél feliratkozás' ? ACTIVE_CAMPAIGN.NEWSLETTER_TRUE_VALUE : ACTIVE_CAMPAIGN.NEWSLETTER_FALSE_VALUE
						}
					]
				}
			}

			const options = {
				method: 'post',
				url: '/apps/active-campaign',
				headers: {
					'content-type': 'application/json'
				},
				data: JSON.stringify(activeCampaignData)
			};

			Axios(options)
				.catch(() => {
					this.serverError = true;
				});
			}
	}
};



// WEBPACK FOOTER //
// ../source/modules/FRM02-form/FRM02-form.js